import "./testDetailsViewEditComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import TestDetailsViewComponent from "./test-details-view/testDetailsViewComponent";
import TestDetailsEditComponent from "./test-details-edit/testDetailsEditComponent";

interface TestPanelDetailsViewEditComponentProps {
    testDetails: any
    onUpdateInformation: Function;
    onModeChange: Function;
    canEdit: boolean;
}

const TestDetailsViewEditComponent = (props: TestPanelDetailsViewEditComponentProps) => {

    const {testDetails, onUpdateInformation, onModeChange, canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [testBasicInformation, setTestBasicInformation] = useState<any>(undefined);

    const handleTestInformationUpdate = useCallback((updatedTestInformation: any, redirectTabId?: "basic_details" | "attachments" | "configuration" | "assigned_labs" | "report_type") => {
        onUpdateInformation(updatedTestInformation, redirectTabId);
        setMode("view");
    }, [onUpdateInformation]);

    const handlePanelInformationEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(() => {
        if (testDetails) {
            setTestBasicInformation(testDetails);
        }
    }, [testDetails]);

    useEffect(() => {
        onModeChange(mode)
    }, [mode, onModeChange])

    return (
        <div className="panel-information-component details-tab-data-wrapper">
            {
                mode === "view" && <TestDetailsViewComponent testDetails={testBasicInformation} canEdit={canEdit}
                                                             onEditModeOpen={() => {
                                                                 setMode("edit")
                                                             }}
                />
            }
            {
                mode === "edit" && <TestDetailsEditComponent
                    testDetails={testBasicInformation}
                    onUpdateComplete={handleTestInformationUpdate}
                    onEditCancel={handlePanelInformationEditCancel}
                />
            }
        </div>
    )

};

export default TestDetailsViewEditComponent;
